/**
 * BỘ TÀI LIỆU BÁO CÁO & KẾ HOẠCH MẠNG XÃ HỘI (DIGITAL & SOCIAL MEDIA)
 * THÁNG 10/2026 — FIT TOUR: DU LỊCH CÓ GUU
 */

export const BAO_CAO_TIKTOK_T10_MARKDOWN = `# BÁO CÁO HIỆU SUẤT KÊNH TIKTOK STUDIO
## THÁNG 10/2026 & NGHIỆM THU ĐỐI SOÁT KPI
**Kênh: @fittour – FIT TOUR - Du lịch có Guu**  
*Thời gian nghiệm thu: 01/10/2026 – 31/10/2026 | Nền tảng: TikTok Studio Creator*  
*Nguồn dữ liệu: TikTok Studio Creator Analytics & Google Sheets đối soát*

---

### 1. TỔNG QUAN HIỆU SUẤT & KẾT QUẢ ĐỐI SOÁT KPI THÁNG 10/2026

Tháng 10/2026 ghi nhận kênh TikTok Studio FIT TOUR (@fittour) hoàn thành vượt kế hoạch cả về sản lượng lẫn lượt xem tích lũy:
* **Sản lượng video:** Xuất bản **31 video** (vượt chỉ tiêu 30 video, đạt **103.3% KPI**), giữ vững kỷ luật 1 clip/ngày.
* **Tổng lượt xem video (Views):** Đạt **25,500 lượt xem (25.5K)** (vượt KPI >25,000 views, đạt **102.0% KPI**, tăng trưởng **+1,500 views (+6.4%)** so với Tháng 9 là 22.7K).
* **Lượt thích (Likes):** Đạt **593 lượt thích** (tăng **+32 likes (+5.7%)** so với Tháng 9).
* **Lượt xem hồ sơ (Profile Views):** Ghi nhận **487 lượt xem profile** du khách ghé thăm kênh.
* **Lượt chia sẻ (Shares):** Đạt **115 lượt chia sẻ** clip cho bạn bè, người thân.
* **Lượt bình luận (Comments):** Ghi nhận **39 bình luận** hỏi tour và tương tác.
* **Hiệu suất trung bình / clip:** Đạt **823 lượt xem / video**.

<div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 14px; margin: 24px 0;">
  <div style="background: #0f172a; color: white; border-radius: 12px; padding: 16px; text-align: center; border: 1px solid rgba(255,255,255,0.1);">
    <div style="font-size: 12px; font-weight: 700; color: #94a3b8; text-transform: uppercase;">Sản Lượng Video (KPI)</div>
    <div style="font-size: 32px; font-weight: 800; color: #38bdf8; margin: 6px 0;">31 Clip</div>
    <div style="font-size: 11.5px; color: #38bdf8;">KPI: 30 clip (<strong>103.3% KPI</strong>)</div>
  </div>

  <div style="background: #0f172a; color: white; border-radius: 12px; padding: 16px; text-align: center; border: 1px solid rgba(255,255,255,0.1);">
    <div style="font-size: 12px; font-weight: 700; color: #94a3b8; text-transform: uppercase;">Tổng Lượt Xem (Views)</div>
    <div style="font-size: 32px; font-weight: 800; color: #4ade80; margin: 6px 0;">25.5K</div>
    <div style="font-size: 11.5px; color: #4ade80;">KPI: > 25,000 (<strong>102.0% KPI</strong>)</div>
  </div>

  <div style="background: #0f172a; color: white; border-radius: 12px; padding: 16px; text-align: center; border: 1px solid rgba(255,255,255,0.1);">
    <div style="font-size: 12px; font-weight: 700; color: #94a3b8; text-transform: uppercase;">Lượt Thích (Likes)</div>
    <div style="font-size: 32px; font-weight: 800; color: #f472b6; margin: 6px 0;">593</div>
    <div style="font-size: 11.5px; color: #f472b6;">Tăng <strong>+5.7% MoM</strong></div>
  </div>

  <div style="background: #0f172a; color: white; border-radius: 12px; padding: 16px; text-align: center; border: 1px solid rgba(255,255,255,0.1);">
    <div style="font-size: 12px; font-weight: 700; color: #94a3b8; text-transform: uppercase;">Lượt Xem Hồ Sơ</div>
    <div style="font-size: 32px; font-weight: 800; color: #fbbf24; margin: 6px 0;">487</div>
    <div style="font-size: 11.5px; color: #fbbf24;">Ghé thăm Profile Bio</div>
  </div>

  <div style="background: #0f172a; color: white; border-radius: 12px; padding: 16px; text-align: center; border: 1px solid rgba(255,255,255,0.1);">
    <div style="font-size: 12px; font-weight: 700; color: #94a3b8; text-transform: uppercase;">Chia Sẻ / Comment</div>
    <div style="font-size: 32px; font-weight: 800; color: #a78bfa; margin: 6px 0;">115 / 39</div>
    <div style="font-size: 11.5px; color: #a78bfa;">Lan tỏa tự nhiên</div>
  </div>
</div>

---

### 2. BẢNG NGHIỆM THU CHỈ SỐ TIKTOK STUDIO THÁNG 10/2026

| Tiêu Chí Đo Lường | Thực Tế Tháng 09 | Chỉ Tiêu KPI Tháng 10 | Thực Tế Tháng 10 | % Đạt KPI | Đánh Giá Vận Hành |
| :--- | :---: | :---: | :---: | :---: | :--- |
| **Số Lượng Video Đăng** | 30 video | **30 video** | **31 video** | **103.3%** | Giữ vững tần suất 1 clip/ngày liên tục 31 ngày |
| **Tổng Lượt Xem (Views)** | 22,700 views | **&gt; 25,000 views** | **25,500 views** | **102.0%** | Tăng +1,500 views (+6.4% MoM) so với tháng trước |
| **Lượt Thích (Likes)** | 533 likes | Theo dõi | **593 likes** | **Hoàn thành** | Tăng +5.7% MoM, hình ảnh Thu Đông hấp dẫn |
| **Lượt Xem Hồ Sơ (Profile)** | 633 views | &gt; 500 views | **487 views** | 97.4% | Giảm -28.3% MoM, cần tối ưu End-screen CTA |
| **Lượt Chia Sẻ (Shares)** | 155 shares | Theo dõi | **115 shares** | **Hoàn thành** | Khách lưu clip gửi bạn bè lập team đi tour |
| **Lượt Bình Luận (Comments)** | 92 comments | Theo dõi | **39 comments** | Đạt | Cần bổ sung câu hỏi mở khảo sát giá tour |
| **Hiệu Suất TB / Video** | 756 view/clip | &gt; 700 view | **823 view/clip** | **117.6%** | Mỗi video tiếp cận trung bình trên 820 lượt xem |

---

### 3. DIỄN BIẾN THEO 5 KỲ TUẦN (ĐỐI SOÁT GOOGLE SHEET)

| Kỳ Hoạt Động | Số Bài | Lượt Xem | TB Xem/Bài | TG Xem TB (s) | Tỷ Lệ Xem Hết | Tương Tác | Likes | Chia Sẻ | Follower Mới |
| :--- | :---: | :---: | :---: | :---: | :---: | :---: | :---: | :---: | :---: |
| **Tuần 1 (28/09 – 04/10)** | 7 | 3,239 | **463** | **4.71s** | **3.31%** | 128 | 98 | 16 | +1 |
| **Tuần 2 (05/10 – 11/10)** | 7 | 2,866 | 409 | 3.65s | 2.86% | 103 | 94 | 4 | +2 |
| **Tuần 3 (12/10 – 18/10)** | 7 | 2,114 | 302 | 3.28s | 2.50% | 77 | 71 | 2 | +1 |
| **Tuần 4 (19/10 – 25/10)** | 7 | 2,770 | 396 | 3.55s | 2.90% | 95 | 89 | 2 | +1 |
| **Tuần 5 (26/10 – 31/10)** | 3 | 2,137 | **427** | 4.01s | 2.66% | 102 | 78 | 11 | +2 |
| **TỔNG HỢP VẬN HÀNH** | **31 Clip** | **25,500\*** | **823\*** | **3.84s** | **2.85%** | **747\*** | **593\*** | **115\*** | **+7** |

*\* Số liệu tổng hợp ghi nhận toàn kênh TikTok Studio trong tháng 10 (bao gồm cả phân phối tiếp nối từ các clip cũ).*

---

### 4. ĐÁNH GIÁ CHUYÊN SÂU & ĐIỂM NGHẼN CẦN THÁO GỠ

1. **Điểm sáng:**
   * Kỷ luật phát sóng đạt mức tối đa (31 video trong 31 ngày).
   * Lượt xem và lượt thích tăng trưởng dương (+6.4% view, +5.7% like), chứng minh các tuyến cảnh sắc Thu Đông (Cửu Trại Câu lá đỏ, tuyết Ladakh) luôn được đón nhận nồng nhiệt.
   * Thời gian xem trung bình ở Tuần 1 đạt mức ấn tượng 4.71s và tỷ lệ xem hết 3.31%.
2. **Điểm nghẽn cần cải thiện:**
   * **Profile Views giảm -28.3%:** Người xem có xu hướng lướt xem giải trí nhưng không bấm vào avatar để xem kênh.
   * **Comments giảm -63.2%:** Video chủ yếu là cảnh đẹp và nhạc nền thư giãn, thiếu các câu hỏi gợi mở thảo luận hoặc thiếu CTA kêu gọi *"Để lại bình luận nhận lịch trình chi tiết"*.
   * **Tỷ lệ xem hết video (Average Retention):** Trung bình toàn tháng ở mức 2.85%, phần lớn người xem thoát sau 3 giây đầu nếu không có yếu tố bất ngờ.

---

### 5. ĐỊNH HƯỚNG BỨT PHÁ THÁNG 11/2026

* **Gia cố Hook 3 giây đầu:** Áp dụng công thức giật tít cảnh báo hoặc bí kíp ngược: *"Đừng đi tour Lệ Giang mùa đông nếu bạn chưa biết 3 lưu ý này..."* để giữ chân du khách qua giây thứ 5.
* **Tích hợp End-screen điều hướng Profile:** 2 giây cuối mỗi video luôn hiển thị banner rõ nét: *"Xem lịch trình & giá tour tại Bio @fittour"* để vực dậy chỉ số profile views lên trên 700 lượt.
* **Tăng cường nội dung dạng Checklist & Tips:** Đẩy mạnh cẩm nang chống sốc độ cao Ladakh/Tây Tạng, tips chụp hình tuyết đẹp, kinh nghiệm làm visa nhanh để tăng lượt Save và Share.

#### Chỉ Tiêu Quản Trị Tháng 11/2026:
* **Sản lượng video:** **30 video** (1 clip/ngày).
* **Tổng lượt xem:** **> 30,000 views** (tăng +17.6%).
* **Lượt xem hồ sơ (Profile):** **> 700 views**.
* **Tương tác gắn kết:** **> 800 tương tác** (kích thích bình luận tư vấn tour).
`;

export const BAO_CAO_FACEBOOK_T10_MARKDOWN = `# BÁO CÁO HIỆU SUẤT FACEBOOK FANPAGE
## THÁNG 10/2026 & ĐỐI SOÁT KPI MỤC TIÊU
**Thương hiệu: FIT TOUR – Du lịch có Guu (Beyond Ordinary Journey)**  
*Thời gian theo dõi: 29/09/2026 – 31/10/2026 (5 kỳ tuần hoạt động)*  
*Nguồn dữ liệu: [Google Sheets Đối Soát](https://docs.google.com/spreadsheets/d/1F7FX-2AtT89U4W4uCoq-fcpILDHYUtbvIW9SLenBCOg/edit?gid=480259893#gid=480259893) • [Báo Cáo Phân Tích Google Docs](https://docs.google.com/document/d/10tMy5QlXAqW052EeW9tKxE-9aHdfLtqeuL61wT7_O9o/edit?usp=sharing)*

---

### 1. TÓM TẮT ĐIỀU HÀNH & KẾT QUẢ ĐỐI SOÁT KPI

> **Quy ước số liệu chuẩn:**  
> • **Bài đăng thường (Nội dung chính):** Hiệu suất tổng của bài đăng, bao gồm cả bài được boost sau đó.  
> • **Bài quảng cáo (Paid Media):** Chỉ số phân phối trả phí riêng lấy từ Facebook Ads Manager.  
> • **Hai nhóm được theo dõi tách biệt:** Không cộng Paid vào KPI nội dung chính để phản ánh trung thực chất lượng sáng tạo tự nhiên.

* **Chỉ tiêu KPI Tháng 10:** **40 bài đăng**, đạt trên **120,000 lượt xem (views)**, trung bình **> 3,000 lượt xem/bài**.
* **Kết quả thực tế (Nội dung chính 5 kỳ tuần):**
  * **Số bài đăng:** **76 bài** (đạt **190% KPI**, vượt chỉ tiêu 36 bài).
  * **Lượt xem (Views):** **336,091 lượt xem** (đạt **280.1% KPI**, vượt +216,091 views, tăng trưởng bứt phá **+142.5% MoM** so với Tháng 9 là 138,580 views).
  * **Người xem tiếp cận (Reach):** **179,326 lượt tiếp cận** (tăng **+150.9% MoM** so với Tháng 9 là 71,459).
  * **Lượt tương tác (Engagement):** **2,343 tương tác** (tăng **+113.8% MoM** so với Tháng 9 là 1,096 tương tác).
    * **1,762** lượt thích / bày tỏ cảm xúc.
    * **427** bình luận (hỏi tour, tư vấn lịch trình mùa Thu Đông).
    * **92** chia sẻ.
    * **41** lưu bài viết tham khảo.
    * **1,163** click liên kết (kéo truy cập về website fittour.vn và Messenger tư vấn).
  * **Hiệu suất trung bình:** **4,422 lượt xem/bài** (vượt xa mục tiêu 3,000 lượt xem/bài, tăng **+37.2%** so với Tháng 9).
* **Paid Media (Theo dõi riêng từ Ads Manager):** 16 bài quảng cáo tạo ra **111,579 lượt xem trả phí**, **66,624 lượt tiếp cận**, **415 tương tác** và **937 lượt click link trả phí**. Không cộng dồn vào bảng organic.

<div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 16px; margin: 24px 0;">
  <div style="background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 12px; padding: 18px; text-align: center;">
    <div style="font-size: 13px; font-weight: 700; color: #1e40af; text-transform: uppercase;">Số Bài Đăng Nội Dung Chính</div>
    <div style="font-size: 34px; font-weight: 800; color: #1d4ed8; margin: 8px 0;">76</div>
    <div style="font-size: 12px; color: #1e40af;">KPI: 40 bài (Đạt <strong>190.0%</strong>)</div>
  </div>

  <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 18px; text-align: center;">
    <div style="font-size: 13px; font-weight: 700; color: #166534; text-transform: uppercase;">Tổng Lượt Xem (Views)</div>
    <div style="font-size: 34px; font-weight: 800; color: #15803d; margin: 8px 0;">336,091</div>
    <div style="font-size: 12px; color: #166534;">KPI: > 120,000 (Đạt <strong>280.1%</strong> • +142.5% MoM)</div>
  </div>

  <div style="background: #faf5ff; border: 1px solid #e9d5ff; border-radius: 12px; padding: 18px; text-align: center;">
    <div style="font-size: 13px; font-weight: 700; color: #7e22ce; text-transform: uppercase;">Người Xem Tiếp Cận (Reach)</div>
    <div style="font-size: 34px; font-weight: 800; color: #9333ea; margin: 8px 0;">179,326</div>
    <div style="font-size: 12px; color: #7e22ce;">Tăng trưởng mạnh <strong>+150.9% MoM</strong></div>
  </div>

  <div style="background: #fff7ed; border: 1px solid #fed7aa; border-radius: 12px; padding: 18px; text-align: center;">
    <div style="font-size: 13px; font-weight: 700; color: #c2410c; text-transform: uppercase;">TB Lượt Xem / Bài</div>
    <div style="font-size: 34px; font-weight: 800; color: #ea580c; margin: 8px 0;">4,422</div>
    <div style="font-size: 12px; color: #c2410c;">Vượt mục tiêu 3,000 (Đỉnh cao <strong>6,969 view/bài</strong>)</div>
  </div>
</div>

---

### 2. HIỆU SUẤT CHI TIẾT THEO 5 KỲ TUẦN (NỘI DUNG CHÍNH)

| Kỳ Hoạt Động | Số Bài | Lượt Xem (Views) | Lượt Tiếp Cận (Reach) | Lượt Tương Tác | TB Xem / Bài | Tỷ Lệ Đóng Góp | Điểm Nhấn Vận Hành |
| :--- | :---: | :---: | :---: | :---: | :---: | :---: | :--- |
| **Tuần 1 (29/09 – 04/10)** | 17 | 52,037 | 26,361 | 425 | 3,061 | 15.5% | Khởi động tháng, tập trung tuyến Thu Đông (Cửu Trại Câu, Lệ Giang, Bhutan) |
| **Tuần 2 (05/10 – 11/10)** | 12 | 29,457 | 15,849 | 304 | 2,455 | 8.8% | Thử nghiệm nội dung kiến thức chuyên sâu; sản lượng và view tạm lắng |
| **Tuần 3 (12/10 – 19/10)** | **20** | **102,043** | **55,751** | **657** | **5,102** | **30.4%** | **Đỉnh cao sản lượng & lượt xem (+246% view): Bùng nổ album ảnh đoàn thực tế** |
| **Tuần 4 (19/10 – 26/10)** | 14 | **97,569** | 51,581 | 523 | **6,969** | 29.0% | **Đỉnh cao chất lượng nội dung: TB xem/bài cao nhất toàn tháng (6,969 view/bài)** |
| **Tuần 5 (27/10 – 31/10)** | 13 | 54,985 | 29,784 | 434 | 4,230 | 16.3% | Về đích ổn định, giữ vững phong độ trên 4,200 views/bài |
| **TỔNG CỘNG 5 TUẦN** | **76 bài** | **336,091** | **179,326** | **2,343** | **4,422** | **100%** | **Vượt xa toàn bộ chỉ tiêu KPI Số bài (190%) và Lượt xem (280.1%)** |

---

### 3. CƠ CẤU & HIỆU SUẤT THEO ĐỊNH DẠNG NỘI DUNG (CONTENT FORMATS)

Phân tích dữ liệu thực tế từ Google Sheet phân loại 76 bài đăng thường xuyên theo 4 định dạng chính:

| Loại Định Dạng | Số Bài | Tỷ Trọng (%) | Lượt Xem (Views) | Lượt Tiếp Cận (Reach) | Lượt Tương Tác | TB Xem / Bài | Vai Trò & Hiệu Quả Thực Tế |
| :--- | :---: | :---: | :---: | :---: | :---: | :---: | :--- |
| 🗂️ **Đa Phương Tiện (Album)** | **45** | **59.2%** | **235,705** | **129,631** | **1,652** | **5,238** | **Định dạng trụ cột (Core Format):** Đóng góp 70.1% tổng views và 70.5% tương tác; tuần 4 đạt đỉnh 10,993 view/bài |
| 🎬 **Thước Phim (Reels)** | 20 | 26.3% | 61,517 | 28,955 | 393 | 3,076 | **Mở rộng tệp khám phá:** Tiếp cận người xem mới chưa follow Page |
| 🖼️ **Ảnh Đơn (Single Photo)** | 9 | 11.8% | 26,541 | 13,668 | 210 | 2,949 | Ảnh phong cảnh độc bản, thông báo ưu đãi nhanh |
| ✍️ **Văn Bản (Text Posts)** | 2 | 2.6% | 12,328 | 7,072 | 88 | 6,164 | Bài viết tâm sự / góc nhìn du lịch sâu sắc tuần 1 |
| **TỔNG CỘNG** | **76 bài** | **100.0%** | **336,091** | **179,326** | **2,343** | **4,422** | **Cơ cấu cân bằng giữa tương tác gắn kết và độ phủ tiếp cận** |

---

### 4. VẤN ĐỀ DỮ LIỆU & CẢNH BÁO PHẠM VI ĐỐI SOÁT (DATA AUDIT & CAVEATS)

> **⚠️ 6 Lưu ý quan trọng khi đối soát số liệu Tháng 10/2026 (theo Mục 6 Báo cáo Google Docs):**  
> 1. **Tổng hợp theo 5 kỳ tuần vận hành:** Toàn bộ dữ liệu 76 bài, 336,091 views, 179,326 reach, 2,343 tương tác là tổng cộng theo 5 kỳ tuần được cung cấp, trung bình có trọng số là 4,422 view/bài.  
> 2. **Paid Media theo dõi riêng:** 16 bài quảng cáo trả phí (111,579 views, 66,624 reach, 415 tương tác, 937 clicks) lấy từ Facebook Ads Manager, tuyệt đối không cộng vào bảng KPI nội dung chính.  
> 3. **Tuần 1 chứa 2 ngày cuối Tháng 9:** Kỳ 29/09–04/10 bao gồm ngày 29 và 30/09; do nguồn dữ liệu tuần không tách rời từng ngày nên không thể loại trừ cơ học.  
> 4. **Ngày 19/10 xuất hiện ở cả 2 kỳ:** Ngày 19/10 có mặt trong cả kỳ 12/10–19/10 và 19/10–26/10 do quy ước cắt kỳ gối đầu; tổng 5 kỳ tuần chưa phải số liệu tháng 10 đã khử trùng lặp theo ngày.  
> 5. **Ký hiệu gạch ngang ("—") là dữ liệu chưa hiển thị:** Ở Tuần 1 và Tuần 2, các chỉ số Chia sẻ, Lưu và Click link không hiển thị; báo cáo giữ nguyên dấu "—", tuyệt đối không mặc định bằng 0.  
> 6. **Nguyên tắc vẽ đồ thị xu hướng:** So sánh giữa 5 kỳ tuần độc lập, không đưa con số tổng hoặc trung bình toàn kỳ thành một điểm dữ liệu trên trục tuần.

---

### 5. PAID MEDIA (THEO DÕI RIÊNG TỪ ADS MANAGER)

Nhóm chỉ số quảng cáo phản ánh phân phối trả phí độc lập để tiếp cận tệp khách hàng tiềm năng mới; không cộng gộp vào KPI nội dung chính nhằm bảo đảm tính khách quan.

| Kỳ Hoạt Động | Số Bài QC | Lượt Xem Trả Phí | Tiếp Cận Trả Phí | Tương Tác | Lượt Click Link | TB Xem / Bài QC |
| :--- | :---: | :---: | :---: | :---: | :---: | :---: |
| **Tuần 1 (29/09 – 04/10)** | 4 | 24,018 | 13,225 | 71 | — | 6,005 |
| **Tuần 2 (05/10 – 11/10)** | 1 | 206 | 207 | 1 | 3 | 206 |
| **Tuần 3 (12/10 – 19/10)** | 6 | 34,152 | 21,760 | 139 | 379 | 5,692 |
| **Tuần 4 (19/10 – 26/10)** | **4** | **52,883** | **31,205** | **204** | **554** | **13,221** |
| **Tuần 5 (27/10 – 31/10)** | 1 | 320 | 227 | 0 | 1 | 320 |
| **TỔNG PAID MEDIA** | **16 bài** | **111,579** | **66,624** | **415** | **937** | **6,974** |

> **Nhận định Paid Media:**  
> • **Tuần 19/10–26/10** là giai đoạn Paid Media đạt hiệu quả phân phối cao nhất với **52,883 lượt xem**, **31,205 reach**, **204 tương tác** và **554 link clicks** (trung bình lên tới **13,221 lượt xem/bài QC**).  
> • **Tuần 12/10–19/10** hỗ trợ mạnh mẽ cho phễu chuyển đổi với **34,152 views** và **379 clicks**.  
> • Lượt click link (937 clicks) đang được đối chiếu liên tục với hệ thống CRM (inbox, lead B2C/B2B và tỷ lệ cọc tour) để tối ưu chi phí CPA.

---

### 6. TƯƠNG TÁC VÀ PHÂN BỔ CHẤT LƯỢNG NỘI DUNG

| Kỳ Hoạt Động | Tổng Tương Tác | Like / Cảm Xúc | Bình Luận | Chia Sẻ | Đã Lưu | Click Link |
| :--- | :---: | :---: | :---: | :---: | :---: | :---: |
| **Tuần 1 (29/09 – 04/10)** | 425 | 310 | 88 | — | — | — |
| **Tuần 2 (05/10 – 11/10)** | 304 | 233 | 77 | — | — | — |
| **Tuần 3 (12/10 – 19/10)** | **657** | **492** | **114** | 31 | 20 | 465 |
| **Tuần 4 (19/10 – 26/10)** | 523 | 397 | 76 | **34** | 16 | **663** |
| **Tuần 5 (27/10 – 31/10)** | 434 | 330 | 72 | 27 | 5 | 35 |
| **TỔNG CỘNG** | **2,343** | **1,762** | **427** | **92** | **41** | **1,163** |

* **Tương tác thảo luận cao:** 427 lượt bình luận chứng minh tệp khách hàng theo dõi Fanpage có nhu cầu du lịch thực tế rất lớn, chủ động để lại câu hỏi về giá tour, lịch khởi hành và thời tiết.
* **Độ lan tỏa và lưu trữ:** Ghi nhận 92 lượt chia sẻ và 41 lượt lưu trữ bài viết (các nội dung cẩm nang mùa hoa, lịch trình mẫu và kinh nghiệm thực chiến).
* **Chuyển đổi lưu lượng:** Đạt **1,163 lượt click link**, trực tiếp dẫn phễu về website Astro fittour.vn để khách hàng tìm hiểu tour độc bản.

---

### 7. ĐỊNH HƯỚNG VẬN HÀNH & KPI ĐỀ XUẤT THÁNG 11/2026

* **Tách bạch 2 luồng KPI:** Tiếp tục duy trì 2 bảng nhập liệu độc lập giữa Organic và Paid Ads ngay từ gốc.
* **Ưu tiên chất lượng trên số lượng:** Duy trì ngưỡng trung bình **> 4,000 lượt xem/bài**, tập trung vào các tuyến điểm mùa Tết và Đông Xuân (Lệ Giang tuyết trắng, Cửu Trại Câu băng tuyết, Bhutan đón năm mới, Sri Lanka ngắm cá voi).
* **Gia tăng nội dung có tỷ lệ Lưu & Chia sẻ:** Tăng cường sản xuất infographic, checklist hành lý, quy định visa mới và lịch trình tour độc bản để tăng giá trị tham khảo lâu dài.
* **Tối ưu phễu chuyển đổi Sales (CRO):** Tích hợp nút kêu gọi hành động (CTA) rõ ràng, liên kết mã chiến dịch để đội ngũ Sales BU nắm bắt đúng nhu cầu của khách hàng khi click từ Fanpage.
* **Chuẩn hóa công thức ngày:** Lưu vết số liệu theo ngày đăng cụ thể để phục vụ việc trích xuất báo cáo tự động linh hoạt trên ERP.

#### Bảng Chỉ Tiêu Đề Xuất Tháng 11/2026:
| Nhóm KPI | Chỉ Số Quản Trị | Mục Tiêu Tháng 11/2026 | Ý Nghĩa Chiến Lược |
| :--- | :--- | :---: | :--- |
| **Sản lượng Content** | Số bài đăng hoàn tất | **45 bài viết** | Đảm bảo tần suất phát sóng đều đặn trong các khung giờ vàng |
| **Độ phủ tự nhiên** | Tổng lượt xem (Views) | **> 180,000 views** | Mở rộng tệp khách hàng biết đến thương hiệu FIT TOUR |
| **Chất lượng nội dung** | Trung bình xem / bài | **> 3,800 views/bài** | Giữ vững chiều sâu và sức hấp dẫn của từng bài viết |
| **Tương tác gắn kết** | Tổng tương tác | **> 1,500 tương tác** | Kích thích khách hàng bình luận, chia sẻ và lưu trữ |
| **Chuyển đổi phễu** | Lượt click link về Web/Chat | **> 800 clicks** | Cung cấp nguồn khách hàng tiềm năng cho đội ngũ Tư vấn |

---
**FIT TOUR – Beyond Ordinary Journey**  
*Phòng Marketing — Bộ phận Social Media & Truyền thông số*  
*Báo cáo hoàn tất và lưu trữ trên hệ thống FIT TOUR ERP.*
`;

export const BAO_CAO_TONG_HOP_MXH_T10_MARKDOWN = `# BÁO CÁO TỔNG HỢP HIỆU SUẤT MẠNG XÃ HỘI & DIGITAL
## THÁNG 10/2026 & ĐỐI SOÁT CHỈ TIÊU KPI ĐA KÊNH
**Thương hiệu: FIT TOUR – Du lịch có Guu (Beyond Ordinary Journey)**  
*Thời gian báo cáo: Tháng 10/2026 (01/10/2026 – 31/10/2026) | Bộ phận: Marketing & Truyền thông số*

---

### 1. BẢNG ĐỐI SOÁT KPI MỤC TIÊU VS THỰC TẾ & KẾ HOẠCH THÁNG 11/2026

Bảng đối chiếu minh bạch chỉ tiêu KPI được giao, phân loại chi tiết từng loại bài viết thực tế trên từng kênh truyền thông trong tháng 10, và đề xuất chỉ tiêu KPI hành động cho tháng 11/2026:

| Kênh Truyền Thông | Phân Loại Chi Tiết (Thực Tế Tháng 10) | Chỉ Số KPI Mục Tiêu | Thực Tế Đạt & % Đạt KPI | Kế Hoạch Đề Xuất Tháng 11/2026 | Đánh Giá & Trạng Thái |
| :--- | :--- | :---: | :---: | :--- | :--- |
| **🌐 Website fittour.vn**<br>*(Astro Native SSR < 0.8s)* | **Tổng: 197 trang xuất bản**<br>• **36** Bài viết cẩm nang mới 100% & Case Study B2B<br>• **84** Trang chuyển đổi Native Astro (83 tour + 1 post)<br>• **77** Trang nâng cấp lớn SEO Schema & SOP kỹ thuật<br>*(➔ 120 trang sản xuất & chuyển đổi mới)* | **40 bài viết mới** | **120 trang mới**<br>(**Đạt 300.0% KPI**)<br>*(Tổng xử lý 197 trang)* | • **45 bài viết mới**<br>• Cẩm nang tour Tết 2027<br>• Tối ưu SEO Schema Tour & FAQ | **XUẤT SẮC**<br>*(Đạt 300.0% KPI sản xuất)*<br><br>[👉 Xem chi tiết](/tai-lieu/bao-cao-website-thang-10-2026) |
| **📱 Facebook Fanpage**<br>*(FIT TOUR - Du lịch có Guu)* | **Tổng: 76 bài Organic (5 kỳ tuần)**<br>• **45** Album đa phương tiện (70.1% view, 70.5% tương tác)<br>• **20** Thước phim ngắn Reels<br>• **9** Ảnh đơn độc bản • **2** Bài viết tâm sự / góc nhìn<br>*(+ 16 bài Paid Ads: 111.5k views, 937 clicks theo dõi riêng)* | **40 bài viết**<br>> 120,000 views<br>(> 3,000 view/bài) | **336,091 views**<br>(**Đạt 280.1% KPI**)<br>**TB: 4,422 view/bài**<br>Reach: 179,326 (+150.9%)<br>Tương tác: 2,343 (+113.8%) | • **45 bài Organic**<br>• **> 180,000 views**<br>• **> 3,800 views TB/bài** ⭐<br>• Tăng nội dung Lưu & Chia sẻ mùa tour Tết/Đông Xuân | **BÙNG NỔ VIEW**<br>*(+142.5% MoM, Đỉnh tuần 4 đạt 6,969 view/bài)*<br><br>[👉 Xem chi tiết](/tai-lieu/bao-cao-facebook-thang-10-2026) |
| **🎵 TikTok Studio**<br>*(Tài khoản @fittour)* | **Tổng: 31 video xuất bản (103.3% KPI)**<br>• Kỷ luật 1 clip/ngày liên tục 31 ngày<br>• Tuyến Thu Đông: Cửu Trại Câu lá đỏ, tuyết Ladakh, Bhutan<br>• 593 like (+5.7% MoM) • 115 share • 487 profile views | **30 video**<br>> 25,000 views | **25,500 views**<br>(**Đạt 102.0% KPI**)<br>TB: 823 view/clip<br>Like: 593 (+5.7%) | • **30 video ngắn** (1 clip/ngày)<br>• **> 30,000 views** (+17.6%)<br>• **> 700 profile views** (End-screen CTA)<br>• Tăng clip checklist & tips du lịch | **ĐẠT & VƯỢT KPI**<br>*(102.0% View, 103.3% Video, 115 lượt chia sẻ)*<br><br>[👉 Xem chi tiết](/tai-lieu/bao-cao-tiktok-thang-10-2026) |

---

### 2. TỔNG QUAN 4 CHỈ SỐ ĐIỀU HÀNH TOÀN HỆ THỐNG

<div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 16px; margin: 24px 0;">
  <div style="background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 12px; padding: 18px; text-align: center;">
    <div style="font-size: 12px; font-weight: 700; color: #1e40af; text-transform: uppercase;">TỔNG ẤN PHẨM SẢN XUẤT</div>
    <div style="font-size: 34px; font-weight: 800; color: #1d4ed8; margin: 6px 0;">304</div>
    <div style="font-size: 11.5px; color: #1e40af;">197 Web + 76 Fanpage + 31 TikTok (<strong>276.4% KPI</strong>)</div>
  </div>

  <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 18px; text-align: center;">
    <div style="font-size: 12px; font-weight: 700; color: #166534; text-transform: uppercase;">LƯỢT XEM TỰ NHIÊN (VIEWS)</div>
    <div style="font-size: 34px; font-weight: 800; color: #15803d; margin: 6px 0;">361,591+</div>
    <div style="font-size: 11.5px; color: #166534;">Tăng trưởng bứt phá <strong>+124.2% MoM</strong> so với T9</div>
  </div>

  <div style="background: #faf5ff; border: 1px solid #e9d5ff; border-radius: 12px; padding: 18px; text-align: center;">
    <div style="font-size: 12px; font-weight: 700; color: #7e22ce; text-transform: uppercase;">CHẤT LƯỢNG PHÂN PHỐI FB</div>
    <div style="font-size: 34px; font-weight: 800; color: #9333ea; margin: 6px 0;">4,422</div>
    <div style="font-size: 11.5px; color: #7e22ce;">TB view/bài (Đỉnh Tuần 4 đạt <strong>6,969 view/bài</strong>)</div>
  </div>

  <div style="background: #fff7ed; border: 1px solid #fed7aa; border-radius: 12px; padding: 18px; text-align: center;">
    <div style="font-size: 12px; font-weight: 700; color: #c2410c; text-transform: uppercase;">TÌNH TRẠNG KPI ĐA KÊNH</div>
    <div style="font-size: 34px; font-weight: 800; color: #ea580c; margin: 6px 0;">3/3 Kênh</div>
    <div style="font-size: 11.5px; color: #c2410c;">Đạt & Vượt 100% mục tiêu • Đối soát minh bạch</div>
  </div>
</div>

---

### 3. ĐIỂM SÁNG NỔI BẬT & BÀI HỌC VẬN HÀNH ĐA KÊNH

1. **Website Astro fittour.vn — Tái cấu trúc nền tảng tốc độ cao:**
   * Hoàn thành 197 trang/bài viết, trong đó có 36 cẩm nang SEO & Case Study mới 100%, 84 trang tour chuyển đổi hoàn toàn sang Astro Native.
   * Tối ưu 77 trang kỹ thuật với cấu trúc dữ liệu JSON-LD Schema (Product, FAQPage, BreadcrumbList) và tuân thủ tiêu chuẩn tương phản màu sắc WCAG AAA.
   * Tốc độ tải trang dưới 0.8s giúp cải thiện vượt bậc trải nghiệm người dùng và tỷ lệ giữ chân khách hàng.

2. **Facebook Fanpage — Bùng nổ lượt xem tự nhiên & album ảnh chân thực:**
   * Lượt xem đạt 336,091 views (tăng +142.5% MoM), lượt tiếp cận đạt 179,326 người (+150.9% MoM).
   * **Định dạng Album ảnh chiếm vị trí độc tôn:** 45 album ảnh hành trình thực tế mang lại 235,705 views (70.1% tổng lượt xem) và 1,652 tương tác (70.5% tổng tương tác).
   * **Paid Media độc lập:** 16 bài quảng cáo đạt 111,579 views, 66,624 reach, 415 tương tác và 937 clicks (đặc biệt tuần 4 đạt 13,221 view/bài QC). Được theo dõi riêng biệt khỏi KPI nội dung chính.

3. **TikTok Studio — Kỷ luật phát sóng & tăng trưởng ổn định:**
   * Giữ vững nhịp độ 1 video/ngày (31 video/31 ngày, đạt 103.3% KPI).
   * Đạt 25,500 lượt xem (102.0% KPI) và 593 lượt thích (+5.7% MoM).
   * Điểm nghẽn cần tháo gỡ: Profile visits giảm -28.3% (487 lượt) và comments giảm -63.2% (39 bình luận) ➔ Cần bổ sung Call-to-Action (CTA) ở 2 giây cuối điều hướng vào trang hồ sơ Bio để tăng tỷ lệ click về web/tư vấn tour.

---

### 4. ĐỀ XUẤT HÀNH ĐỘNG CHO BAN GIÁM ĐỐC & KHỐI KINH DOANH (SALES BU)

* **Tối ưu chuyển đổi từ 2,587 lượt nhấp chuột (Clicks):**  
  Tháng 10 ghi nhận **1,163 lượt click link từ Facebook Organic**, **937 lượt click link từ Paid Ads** và **487 lượt xem hồ sơ TikTok**. Đội ngũ Sales BU cần phối hợp chặt chẽ với Marketing để theo dõi nguồn khách, tối ưu kịch bản tư vấn và gia tăng tỷ lệ chốt cọc tour.
* **Chiến dịch mùa Đông - Xuân & Tết 2027:**  
  Tập trung toàn lực nguồn lực truyền thông đa kênh vào các tuyến điểm mùa cao điểm: **Lệ Giang - Shangri-La tuyết trắng**, **Cửu Trại Câu băng tuyết**, **Bhutan đón Tết an yên**, **Ladakh mùa đông** và **Sri Lanka ngắm cá voi**.
* **Đồng bộ hình ảnh & thông điệp:**  
  Mỗi hành trình tour mới xuất bản trên Website cần được chia nhỏ thành album ảnh trải nghiệm trên Facebook và clip ngắn flycam trên TikTok để tối đa hóa hiệu quả truyền thông chéo (Cross-channel synergy).

---
**FIT TOUR – Beyond Ordinary Journey**  
*Phòng Marketing — Bộ phận Social Media & Digital*  
*Báo cáo hoàn tất và lưu trữ chính thức trên hệ thống FIT TOUR ERP.*
`;


